import { dispatch, registerHandler } from 'nike-re-framejs';
import { of } from 'rxjs';
import { map, tap, filter, flatMap } from 'rxjs/operators';
import { Map } from 'immutable';
import { UploadUtils } from './services/imageUtils';
import PopupNg from '@/ui/PopupNg';
import { defaultMiddlewares } from '@/common/util';

registerHandler('documentsUpload.selectDocument', defaultMiddlewares, (db, [slot, document]) => {
    if (db.getIn(['documentsUpload', 'model', 'selected', slot, 'documentId']) === document.get('documentId')) {
        return db.setIn(['documentsUpload', 'model', 'selected', slot, 'active'], true);
    }

    return db.setIn(['documentsUpload', 'model', 'selected', slot], document.set('active', true));
});

registerHandler('documentsUpload.updateUpload', defaultMiddlewares, (db, [updateUploadEvent, dat, data]) => {
    const { slot, documentId, page } = dat;
    // ignorujeme upload signaly pokial nie sme na spravnej stranke (user pocas uploadu stlacil 'back')
    if (db.getIn(['documentsUpload', 'model', 'selected', slot, 'documentId']) !== documentId) {
        return db;
    }

    //noinspection Eslint
    const map = {
        progress: db => db.mergeIn(['documentsUpload', 'model', 'selected', slot, 'files', page, 'upload'], data),
        error: db =>
            db.update(
                PopupNg.updater.show({
                    style: 'error',
                    title: 'error.unexpected.title',
                    messages: 'error.unexpected.message',
                    close: ['documentsUpload.cleanSingleFailedUpload', { slot, page }]
                })
            ),
        done: db =>
            db
                .setIn(['documentsUpload', 'model', 'version'], data)
                .setIn(['documentsUpload', 'model', 'selected', slot, 'version'], data)
    };
    return map[updateUploadEvent](db);
});

registerHandler('documentsUpload.cleanSingleFailedUpload', defaultMiddlewares, (db, [{ slot, page }]) =>
    db
        .removeIn(['documentsUpload', 'model', 'selected', slot, 'files', page])
        .deleteIn(['documentsUpload', 'model', 'selected', slot, 'version'])
);

registerHandler('documentsUpload.doUpload', defaultMiddlewares, (db, [dat, file]) => {
    const { idZak, slot, slotName, documentId, page, clientHash } = dat;
    function dispatchProgress(im, data, delay) {
        data.resolvedType = im.get('resolvedType');
        data.filename = im.get('filename');
        if (data.resolvedType === 'image') {
            data.imageUrl = im.getIn(['image', 'resized']).url;
        }
        setTimeout(
            () => dispatch(['documentsUpload.updateUpload', 'progress', { slot, documentId, page }, data]),
            delay
        );
    }
    function dispatchError(error) {
        console.error('documentsUpload dispatchError', error);
        setTimeout(() => dispatch(['documentsUpload.updateUpload', 'error', { slot, documentId, page }]), 2000);
    }
    function dispatchDone([, uploadResponse]) {
        // check also for missing version in responses which result from 30x redirects
        if (!uploadResponse.version || (uploadResponse.errors && uploadResponse.errors.MASTER_ERROR)) {
            dispatch(['documentsUpload.updateUpload', 'error', { slot, documentId, page }]);
        } else {
            const data = { slot, documentId, page };
            dispatch(['documentsUpload.updateUpload', 'done', data, uploadResponse.version]);
        }
    }

    of(file)
        .pipe(
            filter(Boolean),
            map(_file => Map({ file: _file })),
            flatMap(UploadUtils.determineFileType),
            flatMap(UploadUtils.resizeIfImage),
            tap(im => dispatchProgress(im, { progress: 1, done: false }, 0)),
            flatMap(
                im =>
                    UploadUtils.upload(im, { idZak, slotName, documentId, page, clientHash }, progress =>
                        dispatchProgress(im, { progress: progress }, 100)
                    ),
                (im, uploadJsonResponse) => [im, uploadJsonResponse]
            ),
            tap(([im]) => dispatchProgress(im, { progress: 100, done: true }, 500))
        )
        .subscribe(dispatchDone, dispatchError);

    return db;
});
